import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';

export function DrawInfoLine({ value }) {
    let laneA = <div className='col-6 px-1'><div className='club-name-draw text-truncate pt-1'>{value.laneA.title}</div><span className='crew-name-draw lh-1'>{value.laneA.suffix}</span></div>;
    let laneB = <div className='col-6 px-1'><div className='club-name-draw text-truncate pt-1'>{value.laneB.title}</div><span className='crew-name-draw lh-1'>{value.laneB.suffix}</span></div>;

    if (value.laneA.winner) {
        laneA = <div className='col-6 club-name-draw'><button type="button" className="btn btn-primary bg-success winner">
            {value.laneA.title} <span className='crew-name'>{value.laneA.suffix}</span><span className="badge badge-light">{value.verdict} {value.winningTime}</span></button></div>;
        laneB = <div className='col-6 club-name-draw'><div className='pt-1 loser text-truncate'>{value.laneB.title}</div><span className='crew-name'>{value.laneB.suffix}</span></div>;
    }
    else if (value.laneB.winner) {
        laneA = <div className='col-6 club-name-draw loser pt-1'>{value.laneA.title} <span className='crew-name'>{value.laneA.suffix}</span></div>;
        laneB = <div className='col-6 club-name-draw'><button type="button" className="btn btn-primary bg-success winner">
            {value.laneB.title} <span className='crew-name'>{value.laneB.suffix}</span><span className="badge badge-light">{value.verdict} {value.winningTime}</span></button></div>;
    }

    return (
        <Card>
            <Card.Header><Row className='lh-1'>
                <div className='col-2 draw-fly-out-row-header'>{value.raceNo}</div>
                <div className='col-3 draw-fly-out-row-header'>{value.raceTimeFormatted}</div>
                <div className='col-2 draw-fly-out-row-header'>{value.round}</div>
                <div className='col-5 draw-fly-out-row-header text-end'>{value.nextRaceNo !== '' && <>Next {value.nextRaceNo}</>}</div>
            </Row>
            </Card.Header>
            <ListGroup.Item><Container><Row>{laneA} {laneB }</Row>
            </Container></ListGroup.Item>
        </Card>
    );
}